import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  Newspaper,
  PlayCircle,
  Calendar,
  ExternalLink,
  Radio,
  Filter
} from "lucide-react";
import article1 from "../assets/article1.webp";
import article2 from "../assets/article2.webp";
import article3 from "../assets/article3.jpg";
import article4 from "../assets/article4.jpg";
import article5 from "../assets/article5.jpeg";
import article6 from "../assets/article6.jpg";
import article7 from "../assets/article7.jpg";
import article8 from "../assets/article8.jpg";
import article9 from "../assets/article9.PNG";
import article10 from "../assets/hernetwork.PNG";
import profileImage from "../assets/team1.webp";

const InThePress = () => {
  const [activeFilter, setActiveFilter] = useState("all");

  const pressItems = [
    {
      type: "article",
      title: "Anambra targets N10bn monthly revenue from taxes",
      source: "Vanguard Media Limited",
      date: "November 26, 2024",
      image: article1,
      link: "https://www.vanguardngr.com/2024/11/anambra-targets-n10bn-monthly-revenue-from-taxes/",
      description: "The Anambra State Internal Revenue Service (AIRS) has set an ambitious target of generating N10 billion in monthly income from tax payments...."
    },
    {
      type: "article",
      title: "Strategic Meeting with The AiRS Solutions Provider; Oasis Management Technologies.",
      source: "Anambra State Inland Revenue Service",
      date: "January 10, 2024",
      image: article2,
      link: "https://airs.an.gov.ng/2024/01/10/ssa-to-gov-soludo-on-igr-technical-mrs-oyeka-amara-holds-strategic-meeting-with-the-airs-solutions-provider-oasis-management-solutions-technologies/",
      description: "SSA to Gov Soludo on IGR (Technical), Mrs Oyeka Amara Holds Strategic Meeting with The AiRS Solutions Provider; Oasis Management Technologies..."
    },
    {
      type: "article",
      title: "Strategic Meeting with Zonal Tax Stations",
      source: "Anambra State Inland Revenue Service",
      date: "January 19, 2024",
      image: article2,
      link: "https://airs.an.gov.ng/2024/01/19/ssa-on-igr-technical-to-gov-soludo-mrs-oyeka-amara-kate-fca-fcti-holds-strategic-meeting-with-zonal-tax-stations/",
      description: "SSA on IGR (Technical) to Gov Soludo, Mrs Oyeka Amara Kate FCA, FCTI Holds Strategic Meeting with Zonal Tax Stations..."
    },
    {
      type: "interview",
      title: "The Heart of a Woman: Mrs. Amara Kate Oyeka’s Journey",
      source: "Sylvia Ngige",
      date: "June 13, 2024",
      image: article3,
      link: "https://www.sylviangige.com/2024/06/13/the-heart-of-a-woman-mrs-amara-kate-oyekas-journey/",
      description: "Around the globe, women are making remarkable strides, tirelessly working to improve the lives of others and the communities they live in..."
    },
    {
      type: "article",
      title: "Group Sensitizes Anambra Traders, Groups on Importance of Tax Payment",
      source: "Anambra Daily",
      date: "November 1, 2024",
      image: article4,
      link: "https://www.anambradaily.com/2024/11/01/group-sensitizes-anambra-traders-groups-on-importance-of-tax-payment/",
      description: "Social and Integral Development Centre (SIDEC) has conducted a one-day sensitization program aimed at increasing awareness of taxation among various stakeholders..."
    },
    {
      type: "video",
      title: "Guest Speaker at Anambra Business Vendors Summit",
      source: "Neat Images",
      date: "June 18, 2024",
      image: profileImage,
      link: "https://www.instagram.com/p/C8W06SkNreo/",
      duration: "1:17"
    },
    {
      type: "article",
      title: "Intense Training for Staff at the Various Tax Stations.",
      source: "Anambra State Inland Revenue Service",
      date: "February 17, 2024",
      image: article2,
      link: "https://airs.an.gov.ng/2024/02/17/airs-ssa-to-gov-soludo-on-igr-technical-mrs-oyeka-amara-kate-fca-fcti-organizes-intense-training-for-staff-at-the-various-tax-stations/",
      description: "AiRS: SSA to Gov Soludo on IGR Technical, Mrs Oyeka Amara Kate FCA FCTI Organizes Intense Training for Staff at the Various Tax Stations..."
    },
    {
      type: "article",
      title: "Anambra engages students in tax awareness",
      source: "Punch News",
      date: "November 22, 2024",
      image: article5,
      link: "https://punchng.com/anambra-engages-students-in-tax-awareness/",
      description: "To deepen the conversation on tax awareness and enlightenment in Anambra State, the management of the Anambra State Internal Revenue Service has held its maiden edition of the AIRS Schools Tax Competition..."
    },
    {
      type: "article",
      title: "Anambra State Govt Cautions Against Tax Evasion To Avoid Sanctions",
      source: "Anambra Broadcasting Service",
      date: "January 23, 2024",
      image: article6,
      link: "https://www.absradiotv.com/2024/01/23/anambra-state-govt-cautions-against-tax- evasion-to-avoid-sanctions/",
      description: "The Senior Special Assistant to Governor Chukwuma Soludo on Internally Generated Revenue, IGR, Mrs Amara Oyeka, has warned against filing tax returns outside the time frame permitted by law..."
    },
    {
      type: "video",
      title: "Introducing New Taxpayer Support with SSA to the Governor, Mrs. Oyeka Amara Kate, M.Sc, FCA, FCTI",
      source: "Anambra State Inland Revenue Service",
      date: "July 23, 2024",
      image: article2,
      link: "https://www.youtube.com/watch?v=XaUQRZZ_YG8",
      description: "In a recent interview, Mrs. Oyeka Amara Kate, SSA IGR Technical to the Governor of Anambra State, discussed new initiatives like Tax Insight Monday, desk officers in ministries, and...",
      duration: "18:20"
    },
    {
      type: "article",
      title: "CITN, Anambra revenue service deepen tax awareness",
      source: "Punch News",
      date: "April 25, 2024",
      image: article7,
      link: "https://punchng.com/citn-anambra-revenue-service-deepen-tax-awareness/",
      description: "Speaking at the event, the lead paper presenter, Nze Sullivan Nwankpo, a former Special Adviser to former President Goodluck Jonathan on Technical Matters, in his presentation..."
    },
    {
      type: "article",
      title: "Evade tax, pay for accumulated years of default if nabbed – Group warns Anambra residents",
      source: "Anambra Daily",
      date: "January 20, 2024",
      image: article8,
      link: "https://www.anambradaily.com/2024/01/20/evade-tax-pay-for-accumulated-years-of-default-if-nabbed-group-warns-anambra-residents/",
      description: "The event organized by a Non-Governmental Organization, Social and Integral Development Centre, SIDEC, in conjunction with the Nigeria Civil Society Situation Room with funding support from..."
    },
    {
      type: "article",
      title: "Obele Women Empowerment Foundation launched in Awka, set to fight for downtrodden",
      source: "The Razor",
      date: "March 26, 2025",
      image: article9,
      link: "https://therazornews.com/obele-women-empowerment-foundation-launched-in-awka-set-to-fight-for-downtrodden/",
      description: "A group, Obele Women Empowerment Foundation (OWEF) has been launched in Awka, the Anambra State capital..."
    },
    {
      type: "article",
      title: "Group Advocates Equal Inheritance Rights for Girls in Igboland",
      source: "Arise News",
      date: "March 25, 2025",
      image: article9,
      link: "https://www.arise.tv/group-advocates-equal-inheritance-rights-for-girls-in-igboland/",
      description: "OWEF has advocated for gender equality, pushing for girl children in Igboland to inherit property like their male counterparts..."
    },
    {
      type: "article",
      title: "Group makes case for inheritance of property by girl children in Igboland",
      source: "Daily Post",
      date: "March 25, 2025",
      image: article9,
      link: "https://dailypost.ng/2025/03/25/group-makes-case-for-inheritance-of-property-by-girl-children-in-igboland/",
      description: "A group, Obele Women Empowerment Foundation, OWEF has made a case for gender equality, saying it would champion the rights..."
    },
    {
      type: "article",
      title: "Obele Women Empowerment Foundation (OWEF) Launched in Grand Style in Awka",
      source: "Fact Reporters",
      date: "March 25, 2025",
      image: article9,
      link: "https://www.factreporters.com.ng/2025/03/obele-women-empowerment-foundation-owef.html",
      description: "Awka, Anambra State – On Tuesday, March 25, 2025, the Golden Tulip Hotel in Awka played host to the official launch of the..."
    },
    {
      type: "article",
      title: "Oyeka Amara Kate: Her Dual Mission in Governance and Advocacy",
      source: "Her Netowrk",
      date: "October 20, 2025",
      image: article10,
      link: "https://www.hernetwork.co/oyeka-amara-kate-her-dual-mission-in-governance-and-advocacy/",
      description: "Oyeka Amara Kate is a seasoned public finance expert and currently serves as the Senior Special Assistant on Internally Generated Revenue (SSA–IGR Technical) to the Governor of Anambra State..."
    }
  ];

  const filteredItems = activeFilter === "all"
    ? pressItems
    : pressItems.filter(item => item.type === activeFilter);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-yellow-50">
      <div className="container mx-auto px-4 pt-32 md:pt-44 pb-16">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">In The Press</h1>
          <p className="text-xl text-gray-600">Media coverage, interviews, and public appearances</p>
        </motion.div>

        {/* Filter Buttons */}
        <motion.div
          className="flex flex-wrap justify-center gap-4 mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <FilterButton
            icon={<Filter />}
            label="All"
            active={activeFilter === "all"}
            onClick={() => setActiveFilter("all")}
          />
          <FilterButton
            icon={<Newspaper />}
            label="Articles"
            active={activeFilter === "article"}
            onClick={() => setActiveFilter("article")}
          />
          <FilterButton
            icon={<PlayCircle />}
            label="Videos"
            active={activeFilter === "video"}
            onClick={() => setActiveFilter("video")}
          />
          <FilterButton
            icon={<Radio />}
            label="Interviews"
            active={activeFilter === "interview"}
            onClick={() => setActiveFilter("interview")}
          />
        </motion.div>

        {/* Press Items Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredItems.map((item, index) => (
            <motion.article
              key={index}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * index }}
            >
              <div className="relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-4 right-4">
                  {item.type === "video" && (
                    <div className="bg-yellow-600 text-white px-3 py-1 rounded-full text-sm flex items-center gap-2">
                      <PlayCircle size={16} />
                      {item.duration}
                    </div>
                  )}
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center gap-2 text-yellow-600 text-sm mb-2">
                  <Calendar size={16} />
                  {item.date}
                </div>

                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {item.title}
                </h3>

                <p className="text-gray-600 mb-4">
                  {item.source}
                </p>

                {item.description && (
                  <p className="text-gray-600 text-sm mb-4">
                    {item.description}
                  </p>
                )}

                <motion.a
                  href={item.link}
                  className="inline-flex items-center gap-2 text-yellow-600 hover:text-yellow-700 font-medium"
                  whileHover={{ x: 5 }}
                >
                  Read More <ExternalLink size={16} />
                </motion.a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
};

const FilterButton = ({ icon, label, active, onClick }) => (
  <motion.button
    className={`flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-colors ${active
      ? "bg-yellow-600 text-white"
      : "bg-white text-gray-600 hover:bg-gray-50"
      }`}
    onClick={onClick}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
  >
    {icon}
    {label}
  </motion.button>
);

export default InThePress;